import dayjs from 'dayjs';

import { ESeverity } from '#shared';

import type { MaoCrewDuty } from '#entities';

export const getTimeSeverityFromCrewDuty = (
  crewDuty: MaoCrewDuty,
  timeZone?: string,
) => {
  const now = dayjs();
  const start = dayjs(crewDuty.OnDutyDateTime).tz(
    timeZone ?? crewDuty.StartAirport.IanaTimeZone,
  );
  const end = dayjs(crewDuty.OffDutyDateTime).tz(
    timeZone ?? crewDuty.StartAirport.IanaTimeZone,
  );
  if (start.isBefore(now.add(2, 'hours')) && end.isAfter(now.add(8, 'hours'))) {
    return ESeverity.LOW;
  }
  if (start.isBefore(now.add(2, 'hours')) && end.isAfter(now.add(4, 'hours'))) {
    return ESeverity.MAJOR;
  }
  if (start.isBefore(now.add(2, 'hours')) && end.isAfter(now)) {
    return ESeverity.CRITICAL;
  }
  return ESeverity.LOW;
};
